<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="product-standard1">
                    <icon name="boxes"></icon>
                    ค่ามาตรฐานโฟม(PS)
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-standard2">
                    <icon name="download"></icon>
                    ค่ามาตรฐานแก้ว(PP)
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-standard3">
                    <icon name="upload"></icon>
                    ค่ามาตรฐาน(PET)
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {
    canInventoryMaterialsImport,
    canInventoryMaterialsExport
} from "../../util/Permissions"

export default {
    name: "product-standard-layout",
    computed: {
        canInventoryMaterialsImport,
        canInventoryMaterialsExport
    },
};
</script>

<style scoped></style>
